import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Avatar,
  Divider,
  Grid,
  IconButton,
  } from '@material-ui/core';
import {
  ArrowDropDown as ClosedIcon,
  ArrowDropUp as OpenedIcon,
  MoreVert as MoreIcon,
} from '@material-ui/icons';
import clsx from 'clsx';

import { push } from 'connected-react-router';

import Profile from '../../../assets/img/profile.svg';
import { useDropdown, useOuterClick } from '../../../hooks';
import Link from '../../link/Link';
import { selectCurrentUser } from '../../../store/modules/users/selectors';
import { useStyles } from './styles';
import { Button, CreateOrganizationModal } from '../../index';


type Props = {
  compact?: boolean;
};

const MainBarUserMenu = ({ compact = false }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { data } = useSelector(selectCurrentUser);
  const { data: user } = useSelector(selectCurrentUser);
  const canUpgradePlan = user?.ref?.active_subscription?.can_upgrade || false;
  const [disabled, setDisabled] = useState(false);

  const {
    isOpened,
    open,
    close,
    toggle,
    closeNow,
  } = useDropdown();

  const ref = useOuterClick<HTMLSpanElement>(closeNow);
  const logOut = useCallback(() => {
    dispatch(push('/dashboard/logout'));
  }, [dispatch]);

  const onClickHandler = useCallback(() => {
    if (compact && !disabled) {
      toggle();
    }
  }, [compact, toggle, disabled]);

  const onMouseEnterHandler = useCallback(() => {
    if (!disabled) {
      if (!compact) {
        open();
      }
    }
  }, [compact, disabled, open]);

  const onMouseLeaveHandler = useCallback(() => {
    if (!disabled) {
      if (!compact) {
        close();
      }
    }
  }, [compact, disabled, close]);

  const toggleDisabledHandler = useCallback((bool: boolean) => {
    setDisabled(bool);
  }, [setDisabled]);

  return (
    <span
      role="button"
      tabIndex={-1}
      ref={ref}
      className={classes.root}
      onMouseEnter={onMouseEnterHandler}
      onMouseLeave={onMouseLeaveHandler}
      onClick={onClickHandler}
      // onKeyDown={toggle}
    >
      {data && (
        <>
          {compact
            ? (
              <IconButton
                tabIndex={-1}
                edge="end"
                color="inherit"
                aria-label="open user menu"
                className={classes.button}
              >
                <MoreIcon className={classes.iconMenu} />
              </IconButton>
            )
            : (
              <Grid
                container
                className={classes.container}
              >
                <Avatar alt="user pic" src={Profile} className={classes.avatar} />
                <Grid item xs>
                  {data.ref.full_name_first_last}
                </Grid>
                {isOpened
                  ? <OpenedIcon />
                  : <ClosedIcon />}
              </Grid>
            )}
        </>
      )}
      <div className={clsx(classes.menu, {
        [classes.menuHidden]: !isOpened,
        [classes.menuCompact]: compact,
      })}
      >
        {canUpgradePlan
        && (
          <div className={classes.menuButtonWrapperItem}>
            {/* 2020.09.09,BN: I specifically want "Upgrade Plan' for this button even though
                               it does not match the "Change Plan" button title in the Profile:Billing screen
            */}
            <Button
              className={classes.menuButtonItem}
              onClick={() => dispatch(push('/dashboard/plans/pricing'))}
            >
              Upgrade Plan
            </Button>
          </div>
        )}
        <Link className={classes.menuItem} to="/dashboard/profile">
          Profile & Preferences
        </Link>
        {data?.ref.organization?.common_name
        && (
          <Link className={classes.menuItem} to={`/dashboard/user/organizations/${data?.ref.organization.id}`}>
            {data?.ref.organization.common_name}
          </Link>
        )}
        {!data?.ref.organization
        && (
          <CreateOrganizationModal
            className={classes.menuItem}
            callback={() => close()}
            disableTopNavigation={toggleDisabledHandler}
          />
        )}
        <Divider />
        <Link
          className={clsx(classes.menuItem, classes.menuItemPrimary)}
          onClick={logOut}
        >
          Sign Out
        </Link>
      </div>
    </span>
  );
};

export default MainBarUserMenu;
